import React, { useState, useEffect } from "react";

function EmbeddingTypesCheckboxes({ value, onChange }) {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Show warning if no checkboxes are selected
    setShowWarning(value.length === 0);
  }, [value]);

  const handleChange = (event) => {
    const { value: checkboxValue, checked } = event.target;
    let updatedEmbeddingTypes;

    if (checked) {
      updatedEmbeddingTypes = [...value, checkboxValue];
    } else {
      updatedEmbeddingTypes = value.filter((type) => type !== checkboxValue);
    }

    onChange(updatedEmbeddingTypes);
  };

  return (
    <div className="mb-3">
      <label htmlFor="embedding-types-group" className="form-label">
        Embedding Types
      </label>
      <div id="embedding-types-group" className="d-flex flex-wrap" aria-labelledby="embedding-types-label">
        <div className="form-check me-2">
          <label className="form-check-label" htmlFor="embeddingCheckbox">
            <input
              className="form-check-input"
              type="checkbox"
              value="MatchFeed::Embedding"
              id="embeddingCheckbox"
              checked={value.includes("MatchFeed::Embedding")}
              onChange={handleChange}
            />
            MatchFeed::Embedding
          </label>
        </div>
        <div className="form-check me-2">
          <label className="form-check-label" htmlFor="aggregatedEmbeddingCheckbox">
            <input
              className="form-check-input"
              type="checkbox"
              value="MatchFeed::AggregatedEmbedding"
              id="aggregatedEmbeddingCheckbox"
              checked={value.includes("MatchFeed::AggregatedEmbedding")}
              onChange={handleChange}
            />
            MatchFeed::AggregatedEmbedding
          </label>
        </div>
      </div>
      {showWarning && (
        <div className="text-warning">
          At least one type must be selected. Default value (which is all) will be applied.
        </div>
      )}
    </div>
  );
}

export default EmbeddingTypesCheckboxes;
